<template>
  <div>
    <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;" class="mt-3 ml-4 mr-4">
      <button-bar 
        @menu-clicked="menuClicked"
        @new-clicked="newClicked"
        @save-clicked="saveClicked"
        @print-clicked="printClicked"
        @delete-clicked="deleteClicked"
        class="navbarmd"
        v-if="user != null"
      />
      <div v-else style="color:white;flex:1;display:flex;flex-direction:row;justify-content:space-between;align-items:center;">
      </div>
      <div style="flex:1;display:flex;flex-direction:row;justify-content:space-between;align-items:center"><div class="navbarmd" /><img src="../assets/lists.png"  style="width:100px;" /><div class="navbarmd" /></div>
      <div style="color:white;flex:1;display:flex;flex-direction:row;justify-content:space-between;align-items:center;">
        <div />
        <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;">
          <div style="text-align:right" v-if="user != null">
            <div class="mt-2" v-if="user != null"><strong>{{ username }}</strong></div>
            <div style="font-size:12px;text-decoration:underline;cursor:pointer" @click="signOut">sign out</div>
          </div>
          <div style="text-align:right" v-else>
            <!-- <div style="text-decoration:underline;cursor:pointer" @click="checkUser">No User</div> -->
            <b-button variant="light" @click="signIn">Sign in with Blockstack</b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="navbarsm">
      <button-bar 
        @menu-clicked="menuClicked"
        @new-clicked="newClicked"
        @save-clicked="saveClicked"
        @print-clicked="printClicked"
        @delete-clicked="deleteClicked"
        class="ml-3 mt-3"
        v-if="user != null"
      />
    </div>
    <side-menu
      v-show="showMenu"
      v-scroll-lock="showMenu"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { EventBus } from '@/event-bus';
import SideMenu from "@/components/SideMenu";
import ButtonBar from '@/components/ButtonBar'

export default {
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapFields([
      'blockstack.user',
      'blockstack.user.username'
    ]),
  },
  mounted() {
    // console.log('Navbar mounted')
  },
  methods: {
    signIn() {
      this.$store.dispatch('signIn')
    },
    signOut() {
      this.$store.dispatch('signOut')
    },
    menuClicked() {
      this.showNewNote()
    },
    newClicked() {
      EventBus.$emit('new-clicked');
    },
    saveClicked() {
      EventBus.$emit('save-clicked');
    },
    printClicked() {
      EventBus.$emit('print-clicked');
    },
    deleteClicked() {
      EventBus.$emit('delete-clicked');
      // this.$store.dispatch('nukeData')
    },
    showNewNote() {
      this.showModal();
    },
    showModal() {
      this.showMenu = true;
    },
    closeModal() {
      this.showMenu = false;
    },
  },
  components: {
    SideMenu,
    ButtonBar
  }
}
</script>

<style scoped>

.bg-blue {
  /* background-color: #2c3e50 !important; */
  background-color: black !important;
}

.navbarsm {
  display: block
}

.navbarmd {
  display: none
}

/* @media screen and (min-width: 500px) { */
@media screen and (min-width: 865px) {

  .navbarsm {
    display: none
  }

  .navbarmd {
    display: block
  }
}

</style>